export const routes = {
	AGENT_AUTH: '/agent/auth',
	AGENT_FEEDBACK: '/agent/feedback',
	AGENT_METRICS: '/agent/metrics',
	AGENT_NOTE: '/agent/transfer/note',
	CONTACT_DATA: '/agent/contact/data',
	CONTACTS_TRANSCRIPT: '/contacts/transcript',
	TEMPLATE_USAGE_STATISTIC: '/analytics/templates',
	END_SESSION: '/endchat',
}
